import dayjs from "dayjs";
import React, { memo } from "react";
import { formatPrice } from "@utils/format";
import { CostStudentType } from "@store/CalculationCost";

interface CalculationCostProp {
  transactionsCostStudent?: CostStudentType[];
}

const CalculationCost = ({ transactionsCostStudent }: CalculationCostProp) => {
  return (
    <div>
      {transactionsCostStudent &&
        transactionsCostStudent.map((item, index) => (
          <div key={index}>
            <h1 className="pl-3 pr-3 formElements__inputSectionHeader header--18">
              {`Cost Preview for Rate Chart #${item.rateChart.id} - ${item.rateChart.name}`}
            </h1>
            <div className="row mb-2">
              <div className="col-sm-8 ">
                <label className="formElements__label">Schedule Date</label>
              </div>
              <div className="col-sm-4 ">
                <label className="formElements__label">Price</label>
              </div>
            </div>
            {item.transactions && (
              <>
                {item.transactions.map((transaction, i) => (
                  <div className="row pt-2 mb-3" key={`${index} ${i}`}>
                    <div className="col-sm-8 ">
                      <label>{`${dayjs(transaction.fromDate).format(
                        "DD/MMMM/YYYY"
                      )} -  ${dayjs(transaction.toDate).format(
                        "DD/MMMM/YYYY"
                      )}`}</label>
                    </div>
                    <div className="col-sm-4 ">
                      <label>{`${formatPrice(transaction.total)}`}</label>
                    </div>
                  </div>
                ))}
                <div className="row pt-2 mb-5 linePriview">
                  <div className="col-sm-8 ">
                    <label>Total:</label>
                  </div>
                  <div className="col-sm-4 ">
                    <label>{`${formatPrice(
                      item.transactions.reduce((a, b) => a + b.total, 0)
                    )}`}</label>
                  </div>
                </div>
              </>
            )}
          </div>
        ))}
    </div>
  );
};

export default memo(CalculationCost);
